import IdName from "core/util/IdName";
import IEntity from "core/util/IEntity";
import Input from "decorator-form/dist/decorators/input/Input";
import { Entity, Field } from "typegraph";
import {
	Param,
	ParamType,
	Refine,
	RefineType
} from "../../../common/entities/paramsWrapper/Params";
import EntitySelect from "../../../common/form/fields/entitySelect/EntitySelect";
import InputType from "../../../common/form/InputType";
import Category from "./Category";
import Stat from "./Stat";
import User from "./User";
import Bookmark from "./Bookmark";
import Attachment from "./Attachment";
import Tag from "common/form/entities/Tag";
import { TopicFeature } from "./TopicFeature";
import showTagSetOnFirstTag from "../ForumTagUtils";
const categorySelect = EntitySelect.registered(
	{ entity: Category, type: "one" },
	"string"
);
const tagSelect = EntitySelect.registered({
		entity: Tag, 
		type: "many",
		getSearchParams:{entityTypeNames:["com.digitalignite.module.forum.entity.Topic"],sortByTagSetName:true},
		onBeforeRenderItem:showTagSetOnFirstTag,
		queryOnStartup:""
	},"string");

@Entity({
	one: "topic",
	many: "topics",
	create: "topicCreate",
	update: "topicUpdate"
})
export default class Topic implements IEntity {
	@Field()
	public id: number;

	@Field()
	@Input({ type: InputType.TEXT, title: "Title", required: true })
	public name: string;

	@Field({ entity: User })
	public createdBy: User;

	@Field({ entity: Stat, aliasFor: "stat" })
	public stats: Stat;

	@Param({ type: ParamType.STRING })
	@Refine({
		label: "Sort",
		options: [
			{
				key: "entry.startDate",
				label: "Recently Added",
				value: "-entry.startDate"
			},
			{ key: "entry.item.name", label: "Name", value: "entry.item.name" }
		],
		type: RefineType.SELECT
	})
	@Field()
	public createdOn: string;

	@Field()
	public modifiedOn: string;

	@Field({ entity: IdName, aliasFor: "parent" })
	public isReply: IdName;

	@Field()
	public flagged: boolean;

	@Field()
	@Input({ type: InputType.TEXT_HTML, title: "Body", required: true })
	public description: string;

	// temporary untill the graphql api supports the same type for both mutations and queries
	@Field({ aliasFor: "category", entity: Category })
	public categoryEntity: Category;

	@Input({ type: categorySelect, title: "Category", required: true })
	public category: number;

	public parent: number;

	@Field({aliasFor: "bookmark", entity: Bookmark})
	public bookmark: Bookmark;

	@Field({ entity: Attachment })
	@Input({ type: InputType.UPLOAD_MULTI, title: "Attachment(s)" })
	public attachments: Attachment[];

	@Field({ aliasFor: "tags", entity: Tag })
	public tagEntities: Tag[];

	@Input({ type: tagSelect, title: "Tags" })
	public tags: number[];

	@Field({ entity: TopicFeature })
	public feature: TopicFeature;

	@Field()
	public followedUser: boolean;

	@Field()
	public followedTopic: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/forum/entity/Topic.ts